import { useState } from "react";
import { LogOut, UserRoundCog } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { IconUserCircle } from "@tabler/icons-react";
import { confirm } from "@/lib/modal-prompt";
import { useAuth } from "@/contexts/AuthContext";
import { useI18n } from "@/contexts/I18nContext";
import { MyProfileDialog } from "./my-profile-dialog";

export function NavUser() {
  const { user, logout } = useAuth();
  const { t } = useI18n();
  const [profileOpen, setProfileOpen] = useState(false);

  const onLogout = async () => {
    const shouldLogout = await confirm(t("auth.logoutConfirm"), {
      title: t("auth.logout"),
      confirmText: t("common.confirm"),
      cancelText: t("common.cancel"),
    });
    if (shouldLogout) logout();
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="h-11 w-11 rounded-full"
            aria-label={t("profile.title")}
            title={t("profile.title")}
          >
            <IconUserCircle className="h-8 w-8" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-60 rounded-lg">
          <DropdownMenuLabel className="font-normal">
            <div className="grid text-left text-sm leading-tight">
              <span className="truncate font-medium">{user?.userId}</span>
              <span className="truncate text-xs text-muted-foreground">
                {user?.username}
              </span>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => setProfileOpen(true)}>
            <UserRoundCog />
            {t("profile.title")}
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={onLogout}>
            <LogOut />
            {t("auth.logout")}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <MyProfileDialog open={profileOpen} onOpenChange={setProfileOpen} />
    </>
  );
}
